import { gql } from '@apollo/client';

export const PROCESS_TEXT_USING_AI = gql`
  mutation ProcessTextUsingAi($text: String!, $context: String, $mode: String!) {
    aiTextProcessingProcessText(text: $text, context: $context, mode: $mode)
  }
`;
